export { default } from './SingleClickHoldsPanel';



// WEBPACK FOOTER //
// ./app/components/borrowing/sidebar/SingleClickHoldsPanel/index.js